import type { IOphthalmologyAsset } from '../../../../../../common/validation/customControls/ophthalmology';
import { FilesUrlBase } from '../../../../../../common/enums/filesUrlBase';
import { OphthalmologyFilePlacement } from '../../../../../../common/validation/customControls/ophthalmology';
import { FlexColumns } from '../../../../elements/FlexColumns';
import { FormGroup } from '../../../../elements/forms/FormGroup';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { RenderAssetThumbnails } from '../../../episodes/common';
import { getFilesByPlacement } from './getFilesByPlacement';

interface IOphthalmologyDropzoneRead {
    files: IOphthalmologyAsset[];
    id: string;
    urlBase?: FilesUrlBase;
}

export function OphthalmologyDropzoneRead(props: IOphthalmologyDropzoneRead) {
    const filesOd = getFilesByPlacement(props.files, OphthalmologyFilePlacement.od);
    const filesOs = getFilesByPlacement(props.files, OphthalmologyFilePlacement.os);
    const filesAanvullend = getFilesByPlacement(props.files, OphthalmologyFilePlacement.aanvullend);

    return (
        <FormGroup>
            <FlexColumns
                noGutters
                sm={12}
            >
                {filesOd.length > 0 && getCol(filesOd, 'OD')}
                {filesOs.length > 0 && getCol(filesOs, 'OS')}
            </FlexColumns>

            {filesAanvullend.length > 0 && (
                <FlexColumns
                    noGutters
                    sm={12}
                >
                    {getCol(filesAanvullend, 'Aanvullend')}
                    <></>
                </FlexColumns>
            )}
        </FormGroup>
    );

    function getCol(assets: IOphthalmologyAsset[], title: string) {
        return (
            <>
                <FormLabel stacked>{title}</FormLabel>
                <RenderAssetThumbnails
                    assets={assets}
                    id={props.id}
                    urlBase={props.urlBase || FilesUrlBase.procedures}
                />
            </>
        );
    }
}
